import { Component, computed, inject, Signal } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';

import { PopoverDropdownComponent } from '@core/components/popover-dropdown/popover-dropdown.component';
import { PopoverOption } from '@core/models/popover.model';
import { PaginationStore } from '@core/store/pagination.store';

@Component({
  selector: 'app-pagination-banner',
  templateUrl: './pagination-banner.component.html',
  styleUrls: ['./pagination-banner.component.scss'],
  imports: [IonButton, IonIcon, PopoverDropdownComponent],
})
export class PaginationBannerComponent {
  private readonly paginationStore = inject(PaginationStore);

  isVisible = this.paginationStore.isVisible;
  paginationText = this.paginationStore.paginationText;
  currentPage = this.paginationStore.currentPage;
  itemsPerPage = this.paginationStore.itemsPerPage;
  totalPages = this.paginationStore.totalPages;
  pageNumbers = this.paginationStore.pageNumbers;
  isFirstPage = this.paginationStore.isFirstPage;
  isLastPage = this.paginationStore.isLastPage;

  itemsPerPageOptions: PopoverOption[] = [
    { label: '10', value: '10' },
    { label: '25', value: '25' },
    { label: '50', value: '50' },
    { label: '100', value: '100' },
  ];

  selectedItemsPerPage: Signal<string> = computed(() =>
    this.itemsPerPage().toString()
  );

  constructor() {
    addIcons({
      chevronBackOutline,
      chevronForwardOutline,
    });
  }

  onItemsPerPageChange(value: string): void {
    const ipp = parseInt(value, 10);
    this.paginationStore.setItemsPerPage(ipp);
  }

  onFirstPage(): void {
    this.paginationStore.firstPage();
  }

  onPreviousPage(): void {
    this.paginationStore.previousPage();
  }

  onNextPage(): void {
    this.paginationStore.nextPage();
  }

  onLastPage(): void {
    this.paginationStore.lastPage();
  }

  onGoToPage(page: number): void {
    this.paginationStore.setPage(page);
  }

  isNumber(value: number | string): boolean {
    return typeof value === 'number';
  }

  asNumber(value: number | string): number {
    return value as number;
  }
}
